export const categories = [
  {
    slug: 'dianying',
    name: '电影',
    description: '海量高清电影资源，涵盖动作、喜剧、科幻、爱情等多种类型',
    icon: 'ri-film-line',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    description: '热播电视剧全集免费在线观看，每日更新最新剧集',
    icon: 'ri-tv-line',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    description: '热门综艺节目高清播放，搞笑、音乐、真人秀一网打尽',
    icon: 'ri-live-line',
  },
  {
    slug: 'dongman',
    name: '动漫',
    description: '日本动漫、国产动漫高清全集，热血、治愈、校园应有尽有',
    icon: 'ri-ghost-line',
  },
];

export const categoryDetails: Record<string, { name: string; description: string; keywords: string[] }> = {
  dianying: {
    name: '电影',
    description: '番茄视频电影频道提供最新最全的高清电影在线观看，涵盖动作片、喜剧片、爱情片、科幻片、恐怖片等，免费高清不缓冲。',
    keywords: ['高清电影', '免费电影', '在线观看', '动作片', '喜剧片', '科幻片'],
  },
  dianshiju: {
    name: '电视剧',
    description: '番茄视频电视剧频道汇集海量热播电视剧全集，国产剧、韩剧、美剧、日剧高清在线播放，每日更新，追剧首选。',
    keywords: ['高清电视剧', '免费电视剧', '热播剧', '国产剧', '韩剧', '美剧'],
  },
  zongyi: {
    name: '综艺',
    description: '番茄视频综艺频道精选热门综艺节目，搞笑综艺、音乐综艺、真人秀、脱口秀高清播放，欢乐不断。',
    keywords: ['综艺节目', '热门综艺', '搞笑综艺', '真人秀', '音乐综艺', '高清综艺'],
  },
  dongman: {
    name: '动漫',
    description: '番茄视频动漫频道提供日本动漫、国产动漫高清全集在线观看，热血、治愈、校园、奇幻等类型动漫免费看。',
    keywords: ['动漫', '日本动漫', '国产动漫', '高清动漫', '动漫全集', '在线观看'],
  },
};